export const encodeCategoryNameForURI = (categoryName: string): string => {
  // We need to replace '%' with '%25' since next.js does not escape '%'
  return encodeURIComponent(categoryName.replace('%', '%25'));
};
